import React, { useEffect } from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { ModulesSection } from './components/ModulesSection';
import { BonusSection } from './components/BonusSection';
import { PricingCard } from './components/PricingCard';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
const PIXEL_ID = '1002798425440252';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      ;
      (function (f: any, b: Document, e: string, v: string) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e) as HTMLScriptElement;
        t.async = !0;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) s.parentNode.insertBefore(t, s);else (b.head || b.documentElement).appendChild(t);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', PIXEL_ID);
      (window as any).fbq('track', 'PageView');
    } catch (err) {
      console.warn('Meta Pixel init skipped:', err);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="3dle1ulujigpf">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-1" data-mp="3dl4k1ljnffut" />
      </noscript>
      <div className="min-h-screen w-full bg-cream text-warmgray overflow-x-hidden flex flex-col items-center" data-id="element-2" data-mp="stccggqermtp">
        <div className="w-full max-w-2xl bg-white shadow-xl" data-id="element-3" data-mp="34nbhsjeuzx5">
          <UrgencyBanner data-id="element-4" data-mp="3udkmtw2p4uae" />
          <Hero data-id="element-5" data-mp="3uc9jfxd5xojt" />
          <PainSection data-id="element-6" data-mp="3uevpttobhy0g" />
          <ModulesSection data-id="element-7" data-mp="d4e5zu7z1ex8" />
          <BonusSection data-id="element-8" data-mp="d4xmd6hz3v95" />
          <PricingCard data-id="element-9" data-mp="d45uo6rhyho5" />
          <Guarantee data-id="element-10" data-mp="d2bj3j2481wq" />
          <Testimonials data-id="element-11" data-mp="85uktw17c75x" />
          <FAQ data-id="element-12" data-mp="86mev2f5hwu3" />
          <FinalCTA data-id="element-13" data-mp="864afiic4cb3" />
          <Footer data-id="element-14" data-mp="83i1pfjpjqra" />
        </div>
      </div>
    </>;
}